export const isEligible = (value) =>
  parseInt(value, 10) < 100 && parseInt(value, 10) > 0;
